<template>
  <!-- <div class="team-link col-sm-3" v-if="!filteredOut"> -->
  <li class="table-item">
    <ul>
      <li class="table-column title">
        <a
          :href="projectLink"
          target="_blank"
          rel="noopener noreferrer"
          class="slate-bold"
        >
          {{ project.title || `Unnamed ${typeOfProject}` }}
        </a>
      </li>
      <li class="table-column date">{{ dateFormatted }}</li>
      <li class="table-column rep">{{ repName }}</li>
      <li class="table-column status">
        <img :src="require(`@/assets/icons/ui/${statusIcon}`)" alt="" />
        {{ statusLabel }}
      </li>
      <!-- Menu Actions -->
      <li class="table-colum actions">
        <button class="btn" @click.stop="$emit('openMenu', project.id)">
          <img src="@/assets/icons/ui/menu-closed.png" alt="menu button" />
        </button>
        <ul class="actions-menu" v-if="showMenuAction">
          <li>
            <img
              src="@/assets/icons/ui/arrow-redo-outline.svg"
              alt="redirect button"
            />
            <a :href="projectLink" target="_blank" rel="noopener noreferrer">
              Open In browser
            </a>
          </li>

          <!-- Mark as Complete -->
          <li
            @click="changeProjectStatus('complete')"
            v-if="showMarkAsComplete"
          >
            <img
              src="@/assets/icons/ui/checkmark-circle-outline.png"
              alt="archive button"
            />
            <span> Mark as Complete </span>
          </li>

          <!-- Archive -->
          <li @click="archiveProject('archived')" v-if="archiveEnabled">
            <img
              src="@/assets/icons/ui/trash-bin-outline.svg"
              alt="archive button"
            />
            <span> Archive </span>
          </li>

          <!-- Unarchive -->
          <li @click="restoreProject()" v-if="!archiveEnabled">
            <img
              src="@/assets/icons/ui/trash-bin-outline-blue.svg"
              alt="archive button"
            />
            <span> Unarchive </span>
          </li>
        </ul>
      </li>
    </ul>
  </li>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import CONSTANTS from "@/constants.js";
export default {
  name: "MyProjectsListCard",
  props: ["project", "typeOfProject", "loading", "openedMenu", "statusClass"],

  computed: {
    ...mapState(["auth", "dealer", "settings"]),

    archiveEnabled() {
      return this.statusLabel?.toLowerCase() !== "archived";
    },

    dateFormatted() {
      const currentDate = new Date(this.project.created_at);
      const day = currentDate.getDate();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    dateDescription() {
      return this.hasRep
        ? ` created by ${this.repName} on ${this.dateFormatted}`
        : ` created on ${this.dateFormatted}`;
    },

    hasRep() {
      return this.project.rep_id;
    },

    isPlaybook() {
      return (
        this.typeOfProject === "playbook" || this.typeOfProject === "catalog"
      );
    },

    isSnapsheet() {
      return this.typeOfProject === "snapsheet";
    },

    isInstantPlaybook() {
      return this.isPlaybook && this.project.pdf_url ? false : true;
    },

    projectLink() {
      return `${this.settings.gameplanUrl}/${this.typeOfProject}s/${this.dealer.rhino_code}/${this.project.id}?passcode=${this.dealer.passcode}`;
    },

    repName() {
      if (this.project.rep_id) {
        for (let index = 0; index < this.dealer.reps.length; index++) {
          const rep = this.dealer.reps[index];
          if (rep.id === this.project.rep_id) {
            return rep.name;
          }
        }
      }
      return "N/A";
    },

    showMenuAction() {
      return this.project?.id === this.openedMenu;
    },

    showMarkAsComplete() {
      return (
        this.project?.status !== CONSTANTS.PROJECT_STATUS.COMPLETE &&
        this.project?.status !== CONSTANTS.PROJECT_STATUS.ARCHIVED
      );
    },

    statusLabel() {
      if (this.project.deleted_at) {
        return "Archived";
      }
      //NewPlaybooks
      if (this.project.status) {
        switch (this.project.status?.toLowerCase()) {
          case "active":
            return "Published";

          case "open":
            return "Published";

          case "published":
            return "Published";

          case "locker":
            return "Open Locker";

          case "quote":
            return "Quote Requested";

          case "archived":
            return "Archived";

          case "complete":
            return "Complete";

          case "draft":
            return "Draft (Autosaved)";

          default:
            return "Draft (Autosaved)";
        }
      }
      //Old Playbooks
      else {
        switch (this.project.status_name) {
          case "Uploaded to S3":
            return "Complete";
          case "Playbook Approved":
            return "Complete";
          case "Archived":
            return "Archived";
          case "published":
            return "Published";
          case "draft":
            return "Draft";
          default:
            return "Processing";
        }
      }
    },

    statusIcon() {
      const imgPath =
        this.project.status?.toLowerCase() === "draft"
          ? "status-empty.png"
          : "status-filled.png";
      return imgPath;
    },
  },

  methods: {
    async changeProjectStatus(status) {
      try {
        if (this.isInstantPlaybook || this.isSnapsheet) {
          const playbookUrl = `${this.settings.endpoint}api/v2/catalog/${this.project.id}`;
          const snapsheetUrl =
            this.settings.endpoint + `api/snapsheets/${this.project.id}`;
          const url = this.isPlaybook ? playbookUrl : snapsheetUrl;
          const params = {
            status,
          };
          await axios.put(url, params, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.auth.apiToken,
            },
          });
          const message =
            status === "archived" ? "Project archived" : "Project updated";
          this.$store.dispatch("showToast", {
            txt: message,
          });
          this.$emit("changeProjectStatus", status);
        } else {
          status === "archived" && (await this.archiveOldPlaybook());
        }
      } catch (error) {
        console.log(error);
      }
    },

    async archiveProject() {
      console.log("archiveProject");
      try {
        if (this.isInstantPlaybook || this.isSnapsheet) {
          const playbookUrl = `${this.settings.endpoint}api/v2/catalog/${this.project.id}/archive`;
          const snapsheetUrl =
            this.settings.endpoint +
            `api/snapsheets/archive/${this.project.id}`;
          const url = this.isPlaybook ? playbookUrl : snapsheetUrl;

          await axios.post(url, null, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.auth.apiToken,
            },
          });
          const message = "Project archived";
          this.$store.dispatch("showToast", {
            txt: message,
          });
          this.$emit("archiveProject");
        } else {
          await this.archiveOldPlaybook();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async archiveOldPlaybook() {
      try {
        await axios({
          method: "POST",
          url: this.settings.playbookEndpoint + "archive-playbook",
          data: { playbook_id: this.project.id },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.auth.apiToken,
          },
        });
        this.project.status_name = "Archived";
        this.$store.dispatch("showToast", {
          txt: `Playbook "${this.project.title}" archived`,
        });
      } catch (error) {
        this.$store.dispatch("showToast", {
          txt: error,
          type: "error",
        });
      }
    },

    async restoreProject() {
      try {
        if (this.isInstantPlaybook || this.isSnapsheet) {
          const playbookUrl = `${this.settings.endpoint}api/v2/catalog/${this.project.id}/restore`;
          const snapsheetUrl =
            this.settings.endpoint +
            `api/snapsheets/restore/${this.project.id}`;
          const url = this.isPlaybook ? playbookUrl : snapsheetUrl;

          await axios.post(url, null, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.auth.apiToken,
            },
          });
          const message = "Project restored";
          this.$store.dispatch("showToast", {
            txt: message,
          });
          this.$emit("restoreProject");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  position: relative;
  width: 10%;
  .actions-menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
    width: 155px;
    /* white */

    background: #ffffff;
    box-shadow: 0px -1.87px 18.2546px rgba(40, 42, 48, 0.16);
    border-radius: 8px;

    position: absolute;
    bottom: -5rem;
    right: 6rem;
    z-index: 10;

    li {
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0.5rem;
      width: 100%;

      &:hover {
        background: #f5f5f5;
        cursor: pointer;
      }
      img {
        width: 1.1rem;
        height: 1.1rem;
        margin-right: 0.5rem;
      }
      a,
      span,
      p {
        color: black;
      }
    }
  }
}
</style>
